import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";

export const GamificationModal = ({
  show,
  onClose,
  title = "Congratulations!",
  message,
  icon = "emoji_events", // default to a trophy/award icon
  primaryBtnColor = "",
}) => {
  const [showModal, setShowModal] = useState(show);

  React.useEffect(() => {
    setShowModal(show);
  }, [show]);

  const handleClose = () => {
    setShowModal(false);
    if (onClose) onClose();
  };

  return (
    <Modal show={showModal} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>
          <span className="material-icons" style={{ color: "#FFD700", fontSize: 32 }}>{icon}</span>
          <span style={{ marginLeft: 12 }}>{title}</span>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div style={{ fontSize: 18, textAlign: "center" }}>{message}</div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          style={{
            backgroundColor: "#0088CC",
            color: "white",
            border: "none",
            borderRadius: "25px",
            padding: "8px 24px",
            fontSize: "16px",
            fontWeight: "500",
            boxShadow: "0 2px 4px rgba(0, 136, 204, 0.3)"
          }}
          onClick={handleClose}
        >
          Ok
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default GamificationModal; 